import { BlockList } from '@zillow/cms-blocks';
import { Box } from '@zillow/constellation-10';
import React from 'react';

import { Block } from '../../types/blocks';

interface FooterTemplateProps {
    footer?: {
        blocks?: Block[];
    };
    relatedArticles?: React.ReactNode;
}

const FooterTemplate = ({
    footer,
    relatedArticles,
}: FooterTemplateProps): React.ReactNode => (
    <Box
        css={{
            marginBlock: '0',
            marginInline: 'auto',
            // v8 $breakpoints.xxl = 1281px → sizes.breakpoint-xxl = 80em = 1280px.
            maxWidth: 'breakpoint-xxl',
        }}
    >
        <Box
            css={{
                // v8 was desktop-first: `padding: 0 $spacing.sm $spacing.xl`
                // with `@media $sm_lte { padding: 0 0 $spacing.xl }`.
                // $sm_lte resolves to (max-width: 480px) — mediaBreakpointMixin
                // takes the *next* breakpoint (md = 481) minus 1 — so the inline
                // padding was 0 below 481px and 16px from 481px up.
                // Panda is mobile-first, so the mobile value becomes the base and
                // `md` (min-width 480px) restores the desktop value.
                // $spacing.sm = 16px = spacing.400 = `default`.
                // $spacing.xl = 48px = spacing.1200 = `layout.looser`.
                paddingTop: '0',
                paddingInline: '0',
                paddingBottom: 'layout.looser',
                md: {
                    paddingInline: 'default',
                },
            }}
        >
            {relatedArticles}

            <BlockList blocks={footer?.blocks || []} />
        </Box>
    </Box>
);

export default FooterTemplate;
